<template>
  <div id="app">
  
  </div>
</template>

<script>
import Api from './apis/api';
export default {
  name: 'App',
  methods: {
    initComyinfo(loc,param) {
      let reqDomainparams = {
          reqdomain: loc,
          terminaltype: 0,
      }
      Api.INITMODEL(reqDomainparams).then(res => {
          if (res.data.status == '001') {
            let mobList = res.data.data
            let templatemain = ""
            if(mobList) {
              mobList.some(item => {
                if(item.type == 1) {
                  templatemain = JSON.parse(item.mallcontent).turl
                  return true
                }
              })
            }
            // 线上 ------------------------------------------------------------------------------ 线上
            if(param) {
              window.location.href = `https://${loc}/${templatemain}.html#/${param}`
            }else {
              window.location.href = `https://${loc}/${templatemain}.html`
            }

            // // 测试 ------------------------------------------------------------------------------ 测试
            // if(param) {
            //   window.location.href = `http://${loc}/${templatemain}.html#/${param}`
            // }else {
            //   window.location.href = `http://${loc}/${templatemain}.html`
            // }

            // // 线下
            // let host = window.location.host
            // window.location.href = `http://${host}/GenRedOne.html#/`
          }
      }).catch(function () {
      })
    }
  },
  mounted() {
    // 线上 ----------------------------------------------------------------- 线上
    let host =  location.host
    let urls = '.cutmall.cn'  //需要改变的后缀名
    let http = ""; // 路径前缀
    let url = ""; // 是否为扫码进入
    let loc = ""; // 请求的域名
    let test = window.location.href
    if(!host.includes(urls)){
        let  index = host.indexOf(".")
        http = host.substring(0,index)
        loc = `${http}${urls}`
    }else {
      loc = host
    }
    let index = test.indexOf(".cn/")
    if(index != -1) {
      url = test.substring(index + 4)
    }
    // // 测试 ----------------------------------------------------------------- 测试
    // let host =  location.host
	  // let urls = '.maboy.cn'  //需要改变的后缀名
    // let http = ""; // 路径前缀
    // let url = ""; // 是否为扫码进入
    // let loc = ""; // 请求的域名
    // let test = window.location.href
    // if(!host.includes(urls)){
    //     let  index = host.indexOf(".")
    //     http = host.substring(0,index)
    //     loc = `${http}${urls}`
    // }else {
    //   loc = host
    // }
    // let index = test.indexOf(".cn/")
    // if(index != -1) {
    //   url = test.substring(index + 4)
    // }

    // // 线下 ------------------------------------------------------------------------- 线下
    // let loc = 'jht.th28.cn'
    // let url = ""; // 是否为扫码进入

    this.initComyinfo(loc,url)
  }
}
</script>

<style>
  #app {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue